import React, { useState,useEffect } from 'react'

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import logo from './../../../assests/logo.jpg';
import bckgrndImage from '../../../assests/background.jpg';
// import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
// import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
// import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import CircularProgress from '@mui/material/CircularProgress';

import { Link } from "react-router-dom";
import { incrementAsync } from '../../../Redux/User/ReduxSliceUser';


// const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: 'center',
//     color: theme.palette.text.secondary,
//   }));


export default function LoginPage(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loginForm, setLoginForm] = useState({
        username:'',
        passwrd:''
    })
    const [showPassword, setShowPassword] = React.useState(false);


  
    const userSelected = useSelector((state) => state.user);

    useEffect(() => {
        let isLoggedInUser = userSelected.userValue.isLoggedIn;
        if(isLoggedInUser){
            console.log("we can navigate")
            checkForwardNavigation();
        }

        function checkForwardNavigation(){
            let userRole = userSelected.userValue.user.rle;
            console.log(userRole)
            // navigate("/Gateway")
            if(userRole === "admin_admin"){
                navigate("/UserAdmLandingPage")
            }else if(userRole === "bank_admin" || userRole === "bank_banker" || userRole === "bank_readOnly"){
                navigate("/lender")
            }else if(userRole === "inspector_admin" || userRole === "inspector_inspector" || userRole === "inspector_readOnly"){
                navigate("/inspectorlanding")
            }
        }

      }, [userSelected, navigate]);



    const handleUserNameChange = (e) =>{
        setLoginForm({
            ...loginForm,
            username:e.target.value
        });
    };

    const handlePassWrdChange = (e) =>{
        setLoginForm({
            ...loginForm,
            passwrd:e.target.value
        });
    };

    // function checkForwardNavigation(){
    //     let userRole = userSelected.userValue.user.rle;
    //     console.log(userRole)
    //     // navigate("/Gateway")
    //     if(userRole === "admin_admin"){
    //         navigate("/UserAdmLandingPage")
    //     }else if(userRole === "bank_admin" || userRole === "bank_banker" || userRole === "bank_readOnly"){
    //         navigate("/lender")
    //     }else if(userRole === "inspector_admin" || userRole === "inspector_inspector" || userRole === "inspector_readOnly"){
    //         navigate("/inspectorlanding")
    //     }
    // }

    // function navigateForward(){
    //     console.log("in navigateForward");
    //     navigate("/Gateway")
    // }


    const submitLoginForm = (e) => {
        e.preventDefault()
        dispatch(incrementAsync(loginForm));

        console.log("in the submitLoginForm");
        console.log(userSelected.userValue.isLoggedIn)
        // navigateForward()
        // dispatch(
        //     login({username:loginForm.username, passwrd:loginForm.passwrd})
        // );
        // if user.loggedinSuccess IS TRUE THEN NAVIGATE TO THE GATEWAY PAGE SO THEY CAN BE DIRECTED TO RIGHT PORTAL
        //  --- CREATE TURNARY THAT IF  LOGGEDINSUCCESS IS TRUE THEN THEY GO INTO THE GATEWAY PAGE
        //  --- TURNARY IF FETCHINGCREDENTIALS IS TRUE THEN THE LOADING SYMBOL SHOWS UP
        // --- IF USERSELECTED HAS ERROR THEN THE FORM IS LISTED WITH ERROR AND THE ERROR SECTION SHOWS UP
        //
        // ELSE DO NOT LEAVE THIS PAGE.
    };

    /**
     * This toggles show for the mui password field
     */
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    
    // checkForwardNavigation();

  return (
      
      <div style={{ backgroundImage: `url(${bckgrndImage})`,height:'100vh',position:'absolute'}}>
        <Box style={{ marginLeft:'25%', marginRight:'25%',marginTop:'25vh'}}>
            <Grid container spacing={2}>
                <Grid item xs={9} sm={8} md={6} lg={6} style={{padding:'5vh',backgroundColor:'white'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Container>
                                {userSelected.userValue.isLoading ? 
                                    <h1>loading...</h1>
                                    :
                                    <h1 style={{textAlign:'center'}}> Login </h1>                                  
                                }
                            </Container>
                        </Grid>
                        <Container>
                            {userSelected.userValue.isLoading ? 
                                <CircularProgress />
                                :
                                <form onSubmit={(e)=>{submitLoginForm(e);}}>
                                    <FormControl  
                                            fullWidth={true} 
                                            sx={{ m: 1}} 
                                            variant="standard"
                                            error={userSelected.userValue.error ? true:false}
                                            >
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <FormControl  
                                                fullWidth={true} 
                                                sx={{ m: 1}} 
                                                variant="standard"
                                                error={userSelected.userValue.error ? true:false}
                                                >
                                            {/* error */}
                                                <InputLabel htmlFor="usernamefield">User Name</InputLabel>
                                                <Input
                                                    id="usernamefield"
                                                    type={'text'}
                                                    onChange={e=>{handleUserNameChange(e)}}
                                                />
                                                {/* <FormHelperText id="usernamefield-error-text">Error</FormHelperText> */}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <FormControl 
                                                fullWidth={true}
                                                sx={{ m: 1 }}
                                                variant="standard"
                                                error={userSelected.userValue.error ? true:false}>
                                                <InputLabel htmlFor="password-input">Password</InputLabel>
                                                <Input
                                                    id="password-input"
                                                    onChange={e=>{handlePassWrdChange(e)}}
                                                    type={showPassword ? 'text' : 'password'}
                                                    endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <Container>
                                                <Button variant='contained' type='submit'>Login</Button>
                                            </Container>
                                        </Grid>
                                        <FormHelperText 
                                            id="usernamefield-error-text"
                                            sx={{
                                                display:userSelected.userValue.error ? "block":"none",
                                            }}
                                            
                                            >Invalid Login.  Please Try again or leave.</FormHelperText>
                                    </FormControl>
                                </form>
                            }
                        </Container>
                    </Grid>
                </Grid>
                <Grid item xs={2} sm={4} md={6} lg={6} style={{backgroundColor:'rgb(11,38,75)'}}>
                    <Container>
                        <img style={{width:'100%', height:'100%'}} src={logo} alt="logo"/>
                    </Container>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={3} md={3} lg={3}>
                    <Button variant='contained'>
                        <Link to="/UserAdmLandingPage" className="btn btn-primary">Admin</Link>     
                    </Button>
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                    <Button variant='contained'>
                        <Link to="/lender" className="btn btn-primary">Lender</Link>     
                    </Button>
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                    <Button variant='contained'>
                        <Link to="/inspectorlanding" className="btn btn-primary">Inspector</Link>     
                    </Button>
                </Grid>
                <Grid item xs={3} md={3} lg={3}>
                    <Button variant='contained'>
                        <Link to="/" className="btn btn-primary">Builder</Link>     
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    <Button variant='contained'>
                        <Link to="/" className="btn btn-primary">Borrower</Link>     
                    </Button>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    <Button variant='contained' 
                    onClick={e=>{
                        console.log(userSelected);
                        dispatch(incrementAsync(loginForm));
                        // dispatch(incrementAsync(5))
                    }}
                    >Redux Test</Button>
                </Grid>
            </Grid>

        
            
        </Box>
    </div>
  )
}